<template>
  <section class="section_full-width-image">
    <Image :source="image" />
  </section>
</template>

<script>
import Image from '@/components/global/Image.vue'
export default {
  name: 'SectionFullWidthImage',
  components: { Image },
  props: {
    image: {
      type: Object,
      default: null,
    },
  },
}
</script>
